let g_devtricker_username_nonce;
let g_devtricker_email_nonce;

async function devtricker_ajax_post_createAccount(form) {
    try {

        const formData = new FormData(form);
        formData.append('action', 'devtricker_action_create_new_user_ajax');

        formData.append('username_nonce', g_devtricker_username_nonce);
        formData.append('email_nonce', g_devtricker_email_nonce);
        formData.append('account_creation_nonce', await devtricker_ajax_get_getDevtrickerAccountCreationNonce());
        formData.append('password_strength', g_devtricker_password_strength);

        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        });

        const result = await response.json();

        if (result.success) {
            devtricker_log(null, devtricker_log_level.INFO, "User created successfull");
            g_devtricker_username_nonce = null;
            g_devtricker_email_nonce = null;
        } else {
            throw new Error(result.data.message);
        }

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}

async function devtricker_ajax_post_isTheUsernameAvailable(username) {
    try {

        const form = new FormData();
        form.append('action', 'devtricker_action_check_username_availability_ajax');
        form.append('username', username);

        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: form
        });

        const result = await response.json();

        if (result.success) {

            if (result.data.available) {
                g_devtricker_username_nonce = result.data.username_nonce;
                devtricker_log(null, devtricker_log_level.INFO, result.data.logMessage);

                return {
                    available: result.data.available,
                    message: result.data.message
                };

            } else {
                devtricker_log(null, devtricker_log_level.INFO, result.data.logMessage);

                return {
                    available: result.data.available,
                    message: result.data.message
                };
            }
        } else {
            throw new Error(result.data.message);
        }

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}

async function devtricker_ajax_post_isTheEmailAvailable(email) {
    try {

        const form = new FormData();
        form.append('action', 'devtricker_action_check_email_existence_ajax');
        form.append('email', email);

        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: form
        });

        const result = await response.json();

        if (result.success) {

            if (result.data.available) {
                g_devtricker_email_nonce = result.data.email_nonce;
                devtricker_log(null, devtricker_log_level.INFO, result.data.logMessage);

                return {
                    available: result.data.available,
                    message: result.data.message
                };

            } else {
                devtricker_log(null, devtricker_log_level.INFO, result.data.logMessage);

                return {
                    available: result.data.available,
                    message: result.data.message
                };
            }
        } else {
            throw new Error(result.data.message);
        }

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}